/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kuendigunggrundsonst2Inputs */

const de__field_kuendigunggrundsonst2 = /** @type {(inputs: _Field_Kuendigunggrundsonst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonstiger Kündigungsgrund`)
};

/**

* @param {_Field_Kuendigunggrundsonst2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kuendigunggrundsonst2 = /** @type {((inputs?: _Field_Kuendigunggrundsonst2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kuendigunggrundsonst2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuendigunggrundsonst2(inputs)
});
export { _field_kuendigunggrundsonst2 as "_field_kuendigungGrundSonst" }